import React from 'react'

function BuildHighlights() {
    return(<div>Comming Soon</div>)
}

export default BuildHighlights;